import { useAuth as useAuthContext } from "../contexts/AuthContext";

export function useAuth() {
  const context = useAuthContext();

  return {
    ...context,
    // isAuthChecked is true when initial loading is complete and we have determined auth state
    isAuthChecked: !context.isLoading,
    // isReady is true when the auth state is fully initialized
    isReady: !context.isLoading && context.isAuthenticated,
  };
}
